ChannelTabs = window.ChannelTabs ?= {}

ChannelTabs.init = ({categoriesBaseUrl}, done) ->
  $ ->
    $(".primary-nav").find("a[href='#{categoriesBaseUrl}']").parent().addClass('active')
    done()


module.exports = ChannelTabs



// WEBPACK FOOTER //
// ./modules/deal/frontend/channel_tabs.coffee